import React from 'react'
import { useTheme } from '../../Hooks/useTheme';

import DropDownNoti from './DropDownNoti'
import DropDownUser from './DropDownUser'

import logoImg from '../../assets/logIn/C-360.png';
import './Nav.css';



function NavBar(props){

    const [theme, toggleTheme] = useTheme();

    const { pathname } = '' //useLocation();
    if (pathname === "/" || pathname === "/registrarse") {
    return <></>;}


    document.addEventListener('scroll', () => {
        var $nav = document.getElementById('nav-cont');
        var $brg = document.getElementById('burger');

        if(window.scrollY > 20 || props.actualFrame === 'cursada'){
            $nav.style.opacity = 0;
            $nav.style.zIndex = -1;
        }else{
            $nav.style.opacity = 1;
            $nav.style.zIndex = 5;
        }

        setTimeout(() => {
            if($brg != null){
                if(window.scrollY > 20 || props.actualFrame === 'cursada'){
                    $brg.style.filter = 'brightness(.9)';
                }else{
                    $brg.style.filter = 'brightness(1)';
                }
            }
        }, 200);
    });



    //Componente
    return(


        <div className='nav-container' id='nav-cont'>
            <div className='nav-sub setpointer' onClick={e => props.setActualFrame('home')}>
                <img src={logoImg} alt="Campus F-360" className={`nav-logo${theme === 'dark' ? ' nav-logo-white' : ''}`} />
            </div>

            <div className='nav-sub'>
                <button className='theme-toggle' onClick={toggleTheme} title={theme === 'dark' ? 'Modo claro' : 'Modo oscuro'}>
                    {theme === 'dark' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="5"/>
                            <line x1="12" y1="1" x2="12" y2="3"/>
                            <line x1="12" y1="21" x2="12" y2="23"/>
                            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
                            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
                            <line x1="1" y1="12" x2="3" y2="12"/>
                            <line x1="21" y1="12" x2="23" y2="12"/>
                            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
                            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
                        </svg>
                    )}
                </button>

                <DropDownNoti usrData={props.usrData} setActualFrame={props.setActualFrame}/>

                <DropDownUser usrData={props.usrData} setActualFrame={props.setActualFrame}/>
            </div>
        </div>
    );
}



export default NavBar
